import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import { Typography } from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'
import { TableEmptyStateSizeT } from './table-empty-state.types'

const containerSizeConfig: Record<TableEmptyStateSizeT, FlattenSimpleInterpolation> = {
  sm: css`
    padding-top: 120px;
    padding-bottom: 120px;
  `,
  base: css`
    padding-top: 200px;
    padding-bottom: 280px;
  `,
}

export const Container = styled.div<{ size?: TableEmptyStateSizeT }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;

  ${({ size = 'base' }) => containerSizeConfig[size]}
`

export const IconContainer = styled.div`
  flex-shrink: 0;
`

export const TextTypography = styled(Typography)`
  color: ${baseTheme.colors.dark100};
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  line-height: 130%;
`
